import React from 'react'
import PlaceholderLayout from './placeholder_layout'

function MediaAttachmentThumbnailPlaceholder({ ...placeholderProps }) {
  return (
    <PlaceholderLayout viewBox='0 0 100 100' {...placeholderProps}>
      <rect x="0" y="0" width="100" height="100" />
    </PlaceholderLayout>
  )
}

export default MediaAttachmentThumbnailPlaceholder